import { RouteConfig } from "vue-router";
import * as SubModules from './sub_module'
export const ShopInvoicesPageRoutes: Array<RouteConfig> = [ {
                path: 'invoices',
                name: 'shop-invoices',
                component: () => import(/* webpackChunkName: "shop-invoices" */ './views/ShopInvoicesPage.vue'),
                children: [
                        ...Object.values(SubModules).flat()
                ]
        },
]